import React, { useState, useEffect } from 'react';

import Card from 'react-bootstrap/Card';
import DynaLoader from './DynaLoader';
import { Link } from 'react-router-dom';
import { fetchTokenMetadata } from '../utils/TokenMetadata';
import { handleError } from '../utils/ErrorHandler';

const TokenCard = (props) => {
  const [loading, setLoading] = useState(true);
  const [tokenSvgDataUri, setTokenSvgDataUri] = useState("");
  const [traitsText, setTraitsText] = useState("");

  useEffect(() => {
    const fetchMetadata = async () => {
      console.log("[TokenCard] Getting metadata for token ID: " + props.tokenId);

      try {
        const metadata = await fetchTokenMetadata(props.tokenId);

        setLoading(false);
        setTokenSvgDataUri(metadata.svgDataUri);
        setTraitsText(metadata.traitsText);

      } catch (err) {
        handleError(err);
      }
    }
    fetchMetadata();
  }, [props.tokenId]);



  const link = "/token/" + props.tokenId;

  if (loading === true) {
    return (
      <Card key={props.tokenId} className="tokenCard">
        <Card.Header>
          <Link to={link}>
            Token ID: {props.tokenId}
          </Link>
        </Card.Header>
        <Card.Body>
          <Card.Title>
          </Card.Title>
          <Link to={link}>
            <div className="cardArtwork">
              <DynaLoader variant="artwork" />
            </div>
          </Link>
        </Card.Body>
      </Card>
    );
  } else {


    return (
      <Card key={props.tokenId} className="tokenCard">
        <Card.Header>
          <Link to={link}>
            Token ID: {props.tokenId}
          </Link>
        </Card.Header>
        <Card.Body>
          <Card.Title>
          </Card.Title>
          <Link to={link}>
            <div className="cardArtwork">
              <img className="galleryImage" alt={"DynaStripes token " + props.tokenId} src={tokenSvgDataUri} />
            </div>
          </Link>
          <div className="cardTraits">
            {traitsText}
          </div>
        </Card.Body>
      </Card>

    );
  }
}

export default TokenCard;
